import { useLocation } from 'react-router';

export const useServiceDescriptionLink = (serviceKey: Nullable<string>): string => {
    const { pathname, search } = useLocation();
    const newPath = serviceKey
        ? `${pathname}/service/${serviceKey.toLowerCase()}`
        : pathname;
    return `${newPath}${search}`;
};
